import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';

import { ApiException } from '../api.exception';
import { isApiErrorMeta, isApiResponse } from '../helpers';

export function apiExceptionInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        const response = error.error;

        if (isApiResponse<null>(response) && isApiErrorMeta(response.meta)) {
          throw new ApiException(response.meta.code, response.meta.message, response);
        }
      }

      throw error;
    }),
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        const response = event.body;

        if (isApiResponse<null>(response) && isApiErrorMeta(response.meta)) {
          throw new ApiException(response.meta.code, response.meta.message, response);
        }
      }
    }),
  );
}
